import { REQUEST_DETAILS } from "../actions/type";

const INITIAL_STATE = {
 
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    
    case REQUEST_DETAILS:
      return {...state,requestDetails:payload};
    default:
      return state;
  }

};
